import * as Icons from 'lucide-react';
import { CircleAlert } from 'lucide-react';
import type { LucideProps } from 'lucide-react';

type IconName = keyof typeof Icons;

interface SafeIconProps extends LucideProps {
  name: string;
}

export const SafeIcon = ({ name, ...props }: SafeIconProps) => {
  const LucideIcon = (Icons as unknown as Record<IconName, React.FC<LucideProps>>)[name as IconName];

  if (!LucideIcon) {
    console.warn(`Icon "${name}" does not exist in lucide-react. Using default icon.`);
    return <CircleAlert {...props} />;
  }

  return <LucideIcon {...props} />;
};
